
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_1vajl_194",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_1vajl_202",
  "pagination-button": "awsui_pagination-button_14rmt_1vajl_219",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_1vajl_226",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_1vajl_229",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_1vajl_233",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_1vajl_236",
  "tabs-tab": "awsui_tabs-tab_14rmt_1vajl_241",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_1vajl_253",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_1vajl_269",
  "refresh": "awsui_refresh_14rmt_1vajl_288",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_1vajl_339",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_1vajl_374",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_1vajl_381",
  "root": "awsui_root_14rmt_1vajl_385",
  "tabs": "awsui_tabs_14rmt_1vajl_194",
  "tabs-content": "awsui_tabs-content_14rmt_1vajl_426",
  "fit-height": "awsui_fit-height_14rmt_1vajl_430",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_1vajl_436",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_1vajl_450",
  "with-paddings": "awsui_with-paddings_14rmt_1vajl_450",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_1vajl_461"
};
  